export const locale = {
    lang: "pt-BR",
    data: {
        HELP: {
            BUTTON_LABEL: "Ajuda"
        }
    }
};
